export const ACCOUNT_TYPES = [
  {
    value: 'individual',
    label: 'Individual',
    levels: {
      cash: 2,
      margin: 6,
    },
    defaultType: 'margin',
    foreignEnabled: true,
    marginEnabled: true,
    cryptoEnabled: false,
    futuresEnabled: true,
    description:
      'A brokerage account with one account owner. Permits for trading stocks and options. This is a taxable account. When the account owner is deceased, all assets are passed on to his or her estate.',
  },
  {
    value: 'joint',
    label: 'Joint',
    levels: {
      cash: 2,
      margin: 6,
    },
    defaultType: 'margin',
    foreignEnabled: true,
    marginEnabled: true,
    cryptoEnabled: false,
    futuresEnabled: true,
    description:
      "A brokerage account with two account owners. Permits for trading in stocks and options. This is a taxable account based on the primary account holder's tax identification number. Each account owner has an undivided ownership in the assets. When one of the account owners die, the surviving account owner retains the rights to the entire account.",
  },
  {
    value: 'rollover_ira',
    label: 'Rollover IRA',
    levels: {
      cash: 3,
    },
    defaultType: 'cash',
    foreignEnabled: false,
    marginEnabled: false,
    cryptoEnabled: false,
    futuresEnabled: true,
    description:
      "Typically, earnings grow tax-deferred and are taxed at your ordinary income tax rate upon withdrawal. Requirements: You may open this type of account if you change jobs or retire and receive an eligible distribution from your former employer's plan, such as a 401(k), 403(b).",
  },
  {
    value: 'roth_ira',
    label: 'Roth IRA',
    levels: {
      cash: 3,
    },
    defaultType: 'cash',
    foreignEnabled: false,
    marginEnabled: false,
    cryptoEnabled: false,
    futuresEnabled: true,
    description:
      'You may withdraw earnings tax-free and penalty-free beginning at age 59½  if the account is at least five years old. You may withdraw contributions tax-free and penalty-free at any time. There is no required minimum distribution at age 70½. You may contribute to a Roth IRA for as long as you earn taxable income. Requirements: You must receive taxable compensation (earned income).',
  },
  {
    value: 'traditional_ira',
    label: 'Traditional IRA',
    levels: {
      cash: 3,
    },
    defaultType: 'cash',
    foreignEnabled: false,
    marginEnabled: false,
    cryptoEnabled: false,
    futuresEnabled: true,
    description:
      'Typically, earnings grow tax-deferred and are taxed at your ordinary income tax rate when you make distributions. Requirements: You must receive taxable compensation (earned income) during the year or file a joint return with a spouse who earns income.',
  },
  {
    value: 'traditional_sep_ira',
    label: 'Traditional SEP IRA',
    levels: {
      cash: 3,
    },
    defaultType: 'cash',
    foreignEnabled: false,
    marginEnabled: false,
    cryptoEnabled: false,
    futuresEnabled: true,
    description:
      'SEP IRA is a basic individual retirement account, much like a traditional IRA. SEP IRAs are for business owners, and contributions are tax-deductible. Investments grow tax-deferred until retirement, when distributions are taxed as income.',
  },
  {
    value: 'custodial',
    label: 'Custodial',
    levels: {
      cash: 2,
    },
    defaultType: 'cash',
    foreignEnabled: false,
    marginEnabled: false,
    cryptoEnabled: false,
    futuresEnabled: false,
    // more details are displayed in actual account-type-picker
    description:
      'A custodial account is an investment account set up by an adult on behalf of a minor, allowing the adult to manage the investments until the minor reaches the legal age.',
  },
];

export const ACCOUNT_FLOWS = {
  individual_cash: [
    'account-information',
    'partner-information',
    'personal-information',
    'investment-information',
    'funding-setup',
    'review-entries',
    'sign-submit',
  ],
  individual_margin: [
    'account-information',
    'partner-information',
    'personal-information',
    'investment-information',
    'funding-setup',
    'review-entries',
    'sign-submit',
  ],
  joint_cash_survivor: [
    'account-information',
    'partner-information',
    'personal-information',
    'investment-information',
    'joint-information',
    'funding-setup',
    'review-entries',
    'sign-submit',
  ],
  joint_margin_survivor: [
    'account-information',
    'partner-information',
    'personal-information',
    'investment-information',
    'joint-information',
    'funding-setup',
    'review-entries',
    'sign-submit',
  ],
  rollover_ira: [
    'account-information',
    'partner-information',
    'personal-information',
    'beneficiary-information',
    'investment-information',
    'funding-setup',
    'review-entries',
    'sign-submit',
  ],
  roth_ira: [
    'account-information',
    'partner-information',
    'personal-information',
    'beneficiary-information',
    'investment-information',
    'funding-setup',
    'review-entries',
    'sign-submit',
  ],
  traditional_ira: [
    'account-information',
    'partner-information',
    'personal-information',
    'beneficiary-information',
    'investment-information',
    'funding-setup',
    'review-entries',
    'sign-submit',
  ],
  traditional_sep_ira: [
    'account-information',
    'partner-information',
    'personal-information',
    'beneficiary-information',
    'investment-information',
    'funding-setup',
    'review-entries',
    'sign-submit',
  ],
  custodial_cash: [
    'account-information',
    'partner-information',
    'personal-information',
    'joint-information',
    'investment-information',
    'funding-setup',
    'review-entries',
    'sign-submit',
  ],
};

export const FLOW_STEPS = {
  'account-information': {
    show: true,
    label: 'Account Information',
    teaser: 'Account and Contact details',
    description: 'Contact information and account details',
  },
  'partner-information': {
    show: true,
    label: 'Additional Agreements',
    teaser: 'Additional Agreement Details',
    description: 'Information About Additional Agreements',
  },
  'personal-information': {
    show: true,
    label: 'Personal Information',
    teaser: 'Personal and address information',
    description: 'Personal details and mailing address information',
  },
  'futures-information': {
    show: true,
    label: 'Futures Information',
    teaser: 'Futures and account information',
    description: 'Futures details and information',
  },
  'joint-information': {
    show: true,
    label: 'Joint/Custodian Details',
    teaser: 'Joint applicants or custodian information',
    description: 'Personal details of joint applicants or custodians',
  },
  'investment-information': {
    show: true,
    label: 'Investment Profile',
    teaser: 'Financial and investment details',
    description: 'Financial details, investment goals and experience',
  },
  'beneficiary-information': {
    show: true,
    label: 'Beneficiaries',
    teaser: 'Add beneficiary information',
    description: 'Primary and Contingent Beneficiary details',
  },
  'foreign-diligence': {
    show: true,
    label: 'Foreign Diligence',
    teaser: 'Foreign applicant details',
    description: 'Collect details and upload documents related to foreign applicants',
  },
  'funding-setup': {
    show: true,
    label: 'Setup Funding',
    teaser: 'ACH funding setup',
    description: 'Learn about the different funding methods available',
  },
  'review-entries': {
    show: false,
    label: 'Review',
    teaser: 'Review previous entries',
    description: 'Review your entries prior to submitting your application',
  },
  'sign-submit': {
    show: true,
    label: 'Sign and Submit',
    teaser: 'Sign and submit your application',
    description: 'Wrap up your application by reviewing the agreements and submitting!',
  },
};

export const ACCOUNT_SUBTYPES = [
  {
    value: 'margin',
    label: 'Margin',
  },
  {
    value: 'cash',
    label: 'Cash',
  },
];

export const OPTION_LEVELS = [
  { value: 0, label: 'No Options' },
  { value: 1, label: 'Level 1: Covered Call Writing & Cash Secured Puts' },
  { value: 2, label: 'Level 2: Purchase Calls/Puts/Long Straddles' },
  { value: 3, label: 'Level 3: Spreads' },
  { value: 4, label: 'Level 4: Equity Put Writing' },
  { value: 5, label: 'Level 5: Uncovered Equity Call Writing' },
  { value: 6, label: 'Level 6: Uncovered Index Calls/Puts' },
];

export const CRYPTO_OPTIONS = [
  { value: false, label: 'No, disable crypto trading.' },
  { value: true, label: 'Yes, enable crypto trading.' },
];

export const FUTURES_OPTIONS = [
  { value: false, label: 'No, do not open a Tradier Futures account' },
  { value: true, label: 'Yes, open a Tradier Futures account' },
];

export const FUTURES_PLATFORM_OPTIONS = [
  { value: 'Tradier Pro Futures', label: 'Tradier Pro Futures' },
  { value: 'Tradier Futures Web', label: 'Tradier Futures Web' },
  { value: 'WealthCharts', label: 'WealthCharts' },
  { value: 'TradingView', label: 'TradingView' },
  { value: 'ORION', label: 'ORION' },
  { value: 'MotiveWave', label: 'MotiveWave' },
  { value: 'Multicharts', label: 'Multicharts' },
  { value: 'Algo Exchange', label: 'Algo Exchange' },
  { value: 'Other', label: 'Other' },
];

export const EMPLOYMENT_OPTIONS = [
  { value: 'EMPLOYED', label: 'Employed' },
  { value: 'SELF_EMPLOYED', label: 'Self-Employed' },
  { value: 'UNEMPLOYED', label: 'Unemployed' },
  { value: 'RETIRED', label: 'Retired' },
  { value: 'STUDENT', label: 'Student' },
];

export const EXPERIENCE_YEARS = [
  { value: 0, label: '0 Years' },
  { value: 1, label: '1 to 2 Years' },
  { value: 2, label: '3 to 5 Years' },
  { value: 3, label: 'More than 5 Years' },
];

export const ANNUAL_INCOME = [
  { value: { min: 0, max: 25000 }, label: '$0 - $25,000' },
  { value: { min: 25001, max: 50000 }, label: '$25,001 - $50,000' },
  { value: { min: 50001, max: 100000 }, label: '$50,001 - $100,000' },
  { value: { min: 100001, max: 200000 }, label: '$100,001 - $200,000' },
  { value: { min: 200001, max: 300000 }, label: '$200,001 - $300,000' },
  { value: { min: 300001, max: 500000 }, label: '$300,001 - $500,000' },
  { value: { min: 500001, max: 1200000 }, label: '$500,001 - $1,200,000' },
  { value: { min: 1200001, max: 9999999 }, label: '$1,200,000+' },
];

export const NETWORTH = [
  { value: { min: 0, max: 50000 }, label: '$0 - $50,000' },
  { value: { min: 50001, max: 100000 }, label: '$50,001 - $100,000' },
  { value: { min: 100001, max: 200000 }, label: '$100,001 - $200,000' },
  { value: { min: 200001, max: 500000 }, label: '$200,001 - $500,000' },
  { value: { min: 500001, max: 1000000 }, label: '$500,001 - $1,000,000' },
  { value: { min: 1000001, max: 5000000 }, label: '$1,000,001 - $5,000,000' },
  { value: { min: 5000001, max: 9999999 }, label: '$5,000,000+' },
];

export const RELATIONSHIPS = [
  { value: 'spouse', label: 'Spouse' },
  { value: 'parent', label: 'Parent' },
  { value: 'child', label: 'Child' },
  { value: 'sibling', label: 'Sibling' },
  { value: 'grandparent', label: 'Grandparent' },
  { value: 'grandchild', label: 'Grandchild' },
  { value: 'other', label: 'Other' },
];

export const PREFIXES = [
  { value: 'Mr.', label: 'Mr.' },
  { value: 'Mrs.', label: 'Mrs.' },
  { value: 'Ms.', label: 'Ms.' },
  { value: 'Dr.', label: 'Dr.' },
];

export const SUFFIXES = [
  { value: 'Jr.', label: 'Jr.' },
  { value: 'Sr.', label: 'Sr.' },
  { value: 'II', label: 'II' },
  { value: 'III', label: 'III' },
  { value: 'IV', label: 'IV' },
];

export const MASKS = {
  any: '',
  phoneNumberUSA: '###-###-####',
  phoneNumberForeign: '+###############',
  ssn: '###-##-####',
  date: '####-##-##',
  postalCode: '#####',
};

export const PLACEHOLDERS = {
  date: 'YYYY-MM-DD',
};

export const CUSTODIAN_TYPES = [
  { value: 'UTMA', label: 'Uniform Transfers to Minors Act' },
  { value: 'UGMA', label: 'Uniform Gifts to Minors Act' },
];

export const WITHDRAWAL_FREQUENCY = [
  { value: 'FREQUENT', label: 'Frequent' },
  { value: 'OCCASIONAL', label: 'Occasional' },
  { value: 'RARE', label: 'Rare' },
];

export const DEPOSIT_TYPE = [
  { value: 'WIRE', label: 'Wire' },
  { value: 'ACAT', label: 'ACAT' },
  { value: 'CHECK', label: 'Check' },
];

export const BUSINESS_NATURE = [
  { value: 'Agriculture, Forestry, and Fishing', label: 'Agriculture, Forestry, and Fishing' },
  { value: 'Banking and Insurance', label: 'Banking and Insurance' },
  { value: 'Construction', label: 'Construction' },
  { value: 'Education', label: 'Education' },
  { value: 'Healthcare', label: 'Healthcare' },
  { value: 'Manufacturing', label: 'Manufacturing' },
  { value: 'Mining', label: 'Mining' },
  { value: 'Public Administration', label: 'Public Administration' },
  { value: 'Real Estate', label: 'Real Estate' },
  { value: 'Retail Trade', label: 'Retail Trade' },
  {
    value: 'Stock, Option, or Commodities Broker Dealer or Exchange',
    label: 'Stock, Option, or Commodities Broker Dealer or Exchange',
  },
  { value: 'Technology Services', label: 'Technology Services' },
  {
    value: 'Transportation, Communications, Electric, Gas and Sanitary Services',
    label: 'Transportation, Communications, Electric, Gas and Sanitary Services',
  },
  { value: 'Wholesale Trade', label: 'Wholesale Trade' },
];

export const REFERRAL_OPTIONS = [
  { value: 'Advertisement', label: 'Advertisement' },
  { value: 'Internet Search', label: 'Internet' },
  { value: 'TV', label: 'TV' },
  { value: 'Social Media', label: 'Social Media' },
  { value: 'Platform', label: 'Platform' },
];

export const SOURCE_OF_FUNDS = [
  { value: 'Investments', label: 'Investments' },
  { value: 'Retirement', label: 'Retirement' },
  { value: 'Employment', label: 'Employment' },
  { value: 'Savings', label: 'Savings' },
  { value: 'Other', label: 'Other' },
];

export const STATUS_PROGRESS = {
  SUBMITTED: {
    displaylabel: 'Submitted',
    description:
      'Your application has been submitted and will be run through a series of automated checks to make sure everything is in order.  You will receive an email from us when it moves to the next step.',
    progress: 65,
    variant: 'success',
  },
  PENDING: {
    displaylabel: 'Submitted',
    description:
      'Your application has been submitted and will be run through a series of automated checks to make sure everything is in order.  You will receive an email from us when it moves to the next step.',
    progress: 65,
    variant: 'success',
  },
  APPROVED: {
    displaylabel: 'Approved',
    description:
      'Your application has been approved! You should received an email from us shortly once your account is finished being set up.',
    progress: 95,
    variant: 'success',
  },
  REJECTED: {
    displaylabel: 'Rejected',
    description: 'Your application is rejected.  Please reach out to a member of our operations team for more details.',
    progress: 100,
    variant: 'danger',
  },
  ERROR: {
    displaylabel: 'Error',
    description:
      'Your application was unable to be completed due to errors.  Please reach out to a member of our operations team for more details.',
    progress: 100,
    variant: 'danger',
  },
  CANCELLED: {
    displaylabel: 'Cancelled',
    description:
      'Your application is cancelled.  Please reach out to a member of our operations team for more details.',
    progress: 100,
    variant: 'danger',
  },
  VERIFIED: {
    displaylabel: 'Verified',
    description:
      'Your application has been verified and is on its way to being reviewed by a member of our operations team.',
    progress: 90,
    variant: 'success',
  },
  COMPLETED: {
    displaylabel: 'Completed',
    description:
      'Your application was completed and you should have received an email notifying you on how to proceed.',
    progress: 100,
    variant: 'success',
  },
};

export const LENGTHS = {
  USERNAME: { min: 3, max: 50 },
  PASSWORD: { min: 12, max: 50 },
  EMAIL: { min: 1, max: 40 },
  NAME: { min: 1, max: 20 },
  TAX_ID: { min: 5, max: 30 },
  STREET_ADDRESS: { min: 5, max: 30 },
};

export const IDENTIFICATION_TYPES = [
  { value: 'PASSPORT', label: 'Passport' },
  { value: 'NATIONAL_ID', label: 'National ID' },
  { value: 'DRIVERS_LICENSE', label: "Driver's License" },
];

export const RISK_OBJECTIVE = [
  {
    label: 'High/Speculation',
    description:
      'I am willing to accept maximum risk to my initial principal to aggressively seek maximum returns, and I understand I could lose most, or all, of the money invested.',
    value: 'HIGH_SPECULATION',
  },
  {
    label: 'Medium/Growth',
    description:
      'I am willing to accept high risk to my principal, including high volatility, to seek high returns over time, and I understand I could lose a substantial amount of the money invested.',
    value: 'MEDIUM_GROWTH',
  },
  {
    label: 'Low/Income',
    description:
      'I am willing to accept low risk to my initial principal, including low volatility, to seek a modest level of portfolio returns.',
    value: 'LOW_INCOME',
  },
];

export const FUTURES_INVESTMENT_OBJECTIVE = [
  {
    label: 'Speculation',
    description:
      'I am willing to accept maximum risk to my initial principal to aggressively seek maximum returns, and I understand I could lose most, or all, of the money invested.',
    value: 'SPECULATION',
  },
  {
    label: 'Hedging',
    description:
      'I plan to buy or sell a futures contract on a commodity exchange as a temporary substitute for an intended later transaction in the cash market. This is typically for a business purpose such as if you are a farmer or jeweler.',
    value: 'HEDGING',
  },
];

export const STATUS_TYPE_COLORS = {
  APPROVED: 'success',
  COMPLETED: 'primary',
  ACTIVE: 'success',
  VERIFIED: 'warning',
  CANCELED: 'warning',
  SUBMITTED: 'info',
  PENDING: 'info',
  ERROR: 'error',
  REJECTED: 'error',
  CLOSED: 'error',
};

// SHA512 SSN without hyphens
export const SSN_BLACKLIST = [
  'fadc234457534a4115c637c43be0a6507dc0874ab4a74ea73fa8164abf75fdac191a0c8b652b7a1c3822d1c6e6b356cc603f8ffd25546e03e3ca5fe10864ae5d',
  'd575893df22c6bc3046609cec1471b9249552a84c99f0931ff22764ffdcf0722bea9a5c5e548023196190e2c9f816c0cc13ef55bcb5f654e603cc8918c7131dc',
  'a0e00759fa6379364c45012aac0c5c9aef693f558af2b900fbf7e71e362f092a688ed4d7b8d50f8e80a525fca628d36241b6d84a4c1326343dd452d849a03979',
  'c70a9c0e2bd3cc36d377a20db643a7d64d492bc5d9ec9c5ca16567f6e2ac9d8860e07cc5a0834db9a0ac2df999e3987fc55d085d91b08c87a1aea038e44e7a75',
  'd94dc68501195e334c02f5070ef6c99a5eb0835d9e9c42aa37b3a982457b112fdbabc074355da1403f5a427df9aa09a555b1b029dcd5ba16ba9b6cb7d5caeefc',
  '249df1478148b68101a1fdc0d62376ea039731119bf31e5b9cf3b6e79897216f8166e56e76a8909211d99b73c7d328b6bb4a3fcfbdfc8d14db04254212db5d37',
  '14d49f8bb975854a306c414e9e889644a899e8db829c7eca64b212c02da718710e2355f4370ae0b55dee3d3681e68051e0ed3fccd785a79873acac778c1d00f6',
  '84317252417dd55eb310d33d7905fd27b845af4404c3470625beeea2457e6ec68ed26cfa49774bb5b6b16cf3e17a73aa84471720aac2b49921151247e645e88d',
  '3c5dd9a78a7e67759ec284bc9e2f1adabb67ab66d3c14e59a992f89258a46de053de35b472d44a2d15b0330e53a0d875cb46a28697a25ad38067c9cf4b5c8596',
  '37eb133d993d244db5deb033fbb7aaae57169383275eff512deefc09e3109414b5edb6965866798b182dcffe71e1a4dfbc094e4636a1a97d69acc1163bf9a7a7',
  'a19a72a3031a6bd45be55d7fa132fd7aa2310ded033754e80761b981de39a1c9f129ece36694dd10014a6d67ccd7ed617c4c04237ad29f9e98bc019aa488a6ce',
  '95c361bbd205cba1ad992d3273b1b594627b2478046673e5422a8f5cb3cd0a3aa9199b04110adf1bc9d3af7e91e243eb9108281debe0c16275497b347a0129f6',
  'e84ff8bc5eaf3df3bc10313a5061f0ee7488c32fe8cac40b5923fa1e9e7e449a2a1bbc5dbf916e7488cd91dd10bd3dd7910b056f4cc06d6873065b4886bbfd93',
  '5d2cf500a3d9d6e3748144babf0c6a44849f3cb970261ed0d4bcacbc7bf4d510ce4e04a9328629e4906c8c813da5805d2630d356b57a46b05d5eb09eeee893ba',
  'c24f59ebedf7bdcff32b2f126c3e4b16e51af6d0214b993a20906ef2660239d0c751016008176f71ae477aa2813fc5020b4a4a6d9fc9ef3f3a17e2f0b87674a1',
  'd5ca83150363884e51824742a2d91df3e4c1fc1586ca0c264f77a09e571f893462853ee84322e933386ca708585df75a80c2557e26e256bb0503054b7f9e46ef',
  '7b7dfc1357b978ff2f2070b2d2e1eb527c5a6531d03395a4d8219f92e07b0f89d2fa2ecf3ac1631b77a952733f324249950cfc7179cdaf56e2de1f6329de07ad',
  'cca7416a287a1d550c0e3076f89438d9ecf119f873c6dbd27e19ec0d2edb4b45314501f12273f649df3205cf38b56522f3c179286e9bb7f3c0fa10b207ea97eb',
  '1a574c2ec1ed2c60b51540f27ade7f49bfdeac0288a17b9b927aca3eeb47efbde4220b6be39aead2343be739b3045ff629ad8ad35fc21dca5760df6ebc4b95d2',
  'ad061028ca9b718a82d92cb30f988d9ea94c35648c357da7560a938669050660bad564c4568b17724a3de94e6972fe511b4c68244289363046ee856bbb720754',
  '90bbc3d275dcbeaa8e23a32e33d825cc3be6fa8f5fbfebdf5df65dbae3c93fe4e1d8a187f8f5ef21ace119c354db2992bd1e973ecbb41e171a9c17f9b97be835',
  '91d4a882f4782f456094435f4cde7dc103d6fc1051da506354d3b50b1a8e775b2baa3b9c7ad743edf1baf3fc3fb8c149b4f1309979f2cf22bc659b1a6dee6e7f',
  '767667384f429f72e05b3dc13153f27dd6afe5b1586dfd81b2a3640f0210b92a91ca495265175e72bb25edfded04560b2a6047dc7f202a8b3de26ae650476b34',
  'a8624e38ae48c61f71cb675dec57d345bdf515f815894dc9d14280d05f2e4fb6e31a30ad951a96335e2a06b8b5de061d53f1643e96164dee41da7d9a11755ff2',
  'ce0347b55ddf1857a65aaa5bf61f82aa9337e21324101f816f5c286766ed54faaec17f0acc4179db3af78fa9681d71e00067461d851b91541cf1942daf6b5b08',
];
